import { render, staticRenderFns } from "./addANewCourseModal.vue?vue&type=template&id=59883ed9"
import script from "./addANewCourseModal.vue?vue&type=script&lang=js"
export * from "./addANewCourseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports